module.exports = __webpack_public_path__ + "img/quest_icon_0063_location2.6c106877.png";